import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CSS/CTA.css';
import avatars from '../assets/images/avatars.png';
import ctaImage from '../assets/images/cta.png'
import cta0Image from '../assets/images/cta0.png'
import cta1Image from '../assets/images/cta1.png'
import cta11Image from '../assets/images/cta11.png'

const CTA = ({ background }) => {

  const [backgroundImage, setBackgroundImage] = useState(ctaImage);

  useEffect(() => {
    const updateBackground = () => {
      if (window.innerWidth < 768) {
        setBackgroundImage(background ? cta11Image : cta0Image);
      } else {
        setBackgroundImage(background ? cta1Image : ctaImage);
      }
    };

    updateBackground(); // Run once on mount
    window.addEventListener('resize', updateBackground);

    return () => window.removeEventListener('resize', updateBackground);
  }, []);

  return (
    <section className="cta-sectionn">
      <div className="cta-background" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <div className="container">
          <div className="cta-content">
            <div className="cta-avatars">
              <img src={avatars} alt="Happy customers" className="avatars-image" />
            </div>
            <h2 className="cta-title">
              Ready to Experience <span className="text-primary">fixINN</span> for Yourself?
            </h2>
            <p className="cta-subtitle">
              Join hundreds of happy customers — book your service today!
            </p>
            <Link to="/contact" className="btn btn-primary cta-button">
              Book a Service
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
